import { registerBlock, registerRelationship } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const fertilityCheckIn: ContentBlock<"program"> = {
  id: makeId("program-fertility-check-in"),
  kind: "program",
  tags: ["assessment", "both-partners", "testing", "pre-cycle"],
  title: "Fertility Check-In",
  subtitle: "Know your numbers — understand where you both stand",
  icon: "🔬",
  body: {
    duration: "2 weeks",
    includes: [
      "Complete hormone panel for her (AMH, FSH, LH, estradiol, thyroid)",
      "Transvaginal ultrasound with antral follicle count",
      "Semen analysis for him",
      "Results review with a fertility nurse",
      "Personalized next-steps report",
    ],
    priceRange: { low: 200, high: 500 },
    currency: "USD",
    status: "coming-soon",
    forWhom: "both",
    category: "assessment",
    moduleIds: [
      makeId("module-female-hormone-baseline"),
      makeId("module-male-fertility-baseline"),
    ],
    phases: [
      {
        title: "Assessment",
        description: "Both partners tested in parallel",
        moduleIds: [
          makeId("module-female-hormone-baseline"),
          makeId("module-male-fertility-baseline"),
        ],
        parallel: true,
      },
    ],
    steps: [
      {
        title: "Schedule",
        description:
          "Book labs and imaging. Her blood draw must be cycle day 2–3.",
      },
      {
        title: "Complete testing",
        description:
          "Hormone panel + ultrasound for her, semen analysis for him.",
      },
      {
        title: "Results review",
        description:
          "30-minute call to walk through all numbers and discuss options.",
      },
    ],
  },
  sources: [
    {
      title:
        "Diagnostic evaluation of the infertile female: a committee opinion",
      journal: "Fertility and Sterility",
      year: 2021,
      evidenceLevel: "expert-opinion",
    },
  ],
};

registerBlock(fertilityCheckIn);

registerRelationship({
  from: makeId("program-fertility-check-in"),
  to: makeId("module-female-hormone-baseline"),
  type: "contains",
});
registerRelationship({
  from: makeId("program-fertility-check-in"),
  to: makeId("module-male-fertility-baseline"),
  type: "contains",
});
